// import React from 'react';
import '../css/location.scss'
// import { Link } from 'react-router-dom';
import { Box } from '@mui/material';

const Location = () => {

  return (
    <div id="location">
      <div id="title">
        <h1>Location  de gradins</h1>
      </div>
      <Box id="content">
        <p>Créacirque offre la possibilité de louer des gradins en bois.<br />
          Les planches sont en bois clair dont certaines sont recouvertes d'un tissu rouge.
          La structure est métallique et modulable.<br />
          Vous avez la possibilité de louer des gradins pour 100, 200 ou 300 places.</p>
        <div className='flex flex-wrap'>
          {/* <img className="v" alt='gradin 11' src='/images/gradins/gradins12.jpeg' /> */}
          <img className="h" alt='gradin 3' src='/images/gradins/Gradins3.jpeg' />
          <img className="h" alt='gradin 4' src='/images/gradins/Gradins4.jpeg' />
          <img className="h" alt='gradin 5' src='/images/gradins/Gradins5.jpeg' />
          <img className="h" alt='gradin 2' src='/images/gradins/Gradins2.jpeg' />
          <img className="h" alt='gradin 1' src='/images/gradins/Gradins1.jpeg' />
          <img className="h" alt='gradin 6' src='/images/gradins/Gradins6.jpg' />
          <img className="h" alt='gradin 7' src='/images/gradins/Gradins7.jpeg' />
          <img className="h" alt='gradin 8' src='/images/gradins/Gradins8.jpeg' />
          {/* <img className="h" alt='gradin 9' src='/images/gradins/gradins9.jpeg' /> */}
          {/* <img className="h" alt='gradin 10' src='/images/gradins/gradins10.jpeg' /> */}
          <img className="h-large" alt='gradin 11' src='/images/gradins/Gradins11.jpeg' />
        </div>
        <p>
          Pour plus d'informations, merci de nous contacter par e-mail à <a href="mailto:creacirque@gmail.com">creacirque@gmail.com</a> ou par téléphone au +32(0) 474/05.21.96.
        </p>
      </Box>
    </div>
  )
};

export default Location;
